import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { to: "/", label: "Home" },
  { to: "/category/politics-policy", label: "Politics" },
  { to: "/category/ghana", label: "Ghana" },
  { to: "/business", label: "Business" },
  { to: "/global-crime-watch", label: "Crime Watch" },
  { to: "/search", label: "Search" },
  { to: "/about", label: "About" },
];

export default function NotFound() {
  return (
    <div className="public-scope min-h-screen bg-paper text-ink font-body flex items-center justify-center px-4">
      <title>Not Found | Be-Apuo Media Intelligence</title>
      <div className="text-center max-w-lg">
        <div className="label-caps text-clay">404</div>
        <h1 className="mt-3 font-editorial font-black text-5xl tracking-tight text-ink">Page not found</h1>
        <p className="mt-4 text-ink/60">The page you are looking for does not exist or has moved.</p>
        <Link to="/" data-testid="notfound-home-link" className="mt-8 inline-block bg-heritage text-paper px-5 py-3 text-sm font-semibold uppercase tracking-widest hover:bg-heritage/90 transition-colors">
          Return home
        </Link>
        <nav className="mt-10 border-t border-ink/10 pt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-testid="notfound-nav">
          {QUICK_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="text-sm text-ink/70 editorial-link hover:text-heritage">{l.label}</Link>
          ))}
        </nav>
      </div>
    </div>
  );
}
